import { Component, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { LoggerProvider, LoggerLevel, LoggerEvent } from '../../providers/logger/logger';
import * as $ from 'jquery'
import { TranslateService } from '@ngx-translate/core';
import { IFormControl } from '../../providers/formbuilder/formcontrol.interface';
 
@Component({
  selector: 'rmt-error',
  templateUrl: 'rmt-error.html'
})
export class RmtErrorComponent implements OnDestroy {
  @Input() show: boolean = false;
  @Input() showOnSubmit: boolean = false;
  @Input() align: string = 'right';
  @Input() errorId: string = '';
  @Input() hint: string;
  @Input() submitAttempts: number = 0;
  @Input() refFormControl: AbstractControl = null;
  @Input() refForm: FormGroup = null;
  @Input() defaultErrors: boolean = false;
  @Input() customMessage: string;
  @Input() icon?: string;
  @Input() iconClass?: string;
  @Input() fieldControl?: IFormControl;

  @ViewChild('errorhint', { read: ElementRef }) errorhint;
  firstShow: boolean = false;
  flashShow: boolean = false;
  flashActive: boolean = false;
  flashTimeout;
  fadeOut: boolean = false;
  fadeOutTimeout;
  opacity = 0.0;
  opacityHint = 1.0;
  lastSubmitAttempts: number = 0;
  isLogError: boolean = false;
  private _onChangeSubscription = null;
  
  constructor(private translate: TranslateService) {
  }

  ngOnDestroy() {
    if (this._onChangeSubscription)
      this._onChangeSubscription.unsubscribe();
    this._onChangeSubscription = null;
  }

  flash() {
    if (this.flashTimeout)
      window.clearTimeout(this.flashTimeout);
    if (this.fadeOutTimeout)
      window.clearTimeout(this.fadeOutTimeout);
    this.fadeOut = false;    
    this.fadeOutTimeout = null;
    this.opacity = 1.0;

    this.flashActive = true;
    this.flashTimeout = window.setTimeout(() => {
      this.flashTimeout = null;
      this.flashActive = false;
    }, 1000);
  }

  checkShow() {
    let show = false;
    let submitAttempts = this.submitAttempts;

    if (this.defaultErrors && this.refFormControl && this.refFormControl.touched && this.getErrorMessage(this.refFormControl.errors))
      show = true;
    if (this.show || this.flashActive || this.fadeOut)
      show = true;
    else if (this.showOnSubmit && this.refForm && this.refForm['submitAttempts']) {
      submitAttempts += this.refForm['submitAttempts'];
      show = true;
    }
    else if (this.refFormControl && !this.refFormControl.valid && !this.refFormControl.disabled) {      
      if (this.refFormControl.parent && this.refFormControl.parent['submitAttempts']) {
        submitAttempts += this.refFormControl.parent['submitAttempts'];
        show = true;
      }
      else if (this.submitAttempts > 0)
        show = true;
      else if (this.refFormControl.dirty && this.refFormControl.touched) {
        show = true;
      }  
    }

    if (submitAttempts < this.lastSubmitAttempts) // i.e. when it has resetted meanwhile
      this.lastSubmitAttempts = submitAttempts;

    if (show && !this.fadeOut) {
      this.fadeOut = false;
      if (this.fadeOutTimeout)
        window.clearTimeout(this.fadeOutTimeout);
      this.fadeOutTimeout = null;
      if (this.opacity !== 1.0 || !this.firstShow || this.lastSubmitAttempts !== submitAttempts) {
        this.flashShow = false;
        // requires a short delay to process the change and reactivate it
        window.setTimeout(() => {          
          this.flashShow = false;
          this.opacity = 1.0;
          this.opacityHint = 0.0;
          
          if (this.errorhint) {
            const error = this.errorhint.nativeElement.getElementsByClassName('error');
            if (error && error.length > 0)
              this.errorhint.nativeElement.style.maxHeight = (error[0].offsetHeight + 25) + 'px';              
            
            const forms = $(this.errorhint.nativeElement).parents('form');
            if (forms && forms.length > 0) {              
              const form = forms[forms.length - 1];
              let top = form.offsetHeight;
              const scrolls = $(this.errorhint.nativeElement).parents('.scroll-content');
              if (scrolls && scrolls.length > 0) {
                let el: any = form;
                while (el && el !== scrolls[0]) {
                  top += el.offsetTop;
                  el = el.offsetParent;
                }  
              }
              
              let el: any = this.errorhint.nativeElement;
              while (el && el !== form) {
                top -= el.offsetTop;
                el = el.offsetParent;
              }
              if (top <= 0)              
                this.errorhint.nativeElement.style.marginBottom = '0px';
              else
                this.errorhint.nativeElement.style.marginBottom = '-25px';
            }
          }          
        }, 100);
      }
      this.firstShow = true;
    }
    else if (this.firstShow && !this.fadeOutTimeout) {      
      this.flashShow = false;      
      if (this.opacity > 0.0) {
        show = true;        
        this.fadeOut = true;
        this.fadeOutTimeout = window.setTimeout(() => {
          this.fadeOutTimeout = null;
          this.fadeOut = false;
        }, 500);
        window.requestAnimationFrame(() => {          
          this.opacity = 0.0;
          this.opacityHint = 1.0;
        });
        if (this.errorhint)
          this.errorhint.nativeElement.style.maxHeight = '25px';
      }
    }
    this.lastSubmitAttempts = submitAttempts;

    if (!this.isLogError && show && this.errorhint) {
      const error = this.errorhint.nativeElement.getElementsByClassName('error');
      this.logError(error);
      this.isLogError = true;
      if (!this._onChangeSubscription && this.refFormControl)
        this._onChangeSubscription = this.refFormControl.statusChanges.debounceTime(1000).subscribe(() => {
          this.logError(error);
        });
    }
    if (!show && this.isLogError) {
      this.isLogError = false;
      if (this._onChangeSubscription)
        this._onChangeSubscription.unsubscribe();
      this._onChangeSubscription = null;
    }

    return show;
  }

  logError(error){
    LoggerProvider.log(this, LoggerLevel.Info, LoggerEvent.FormError, 'Form Input error', error[0].innerText)
  }

  getErrorId(type='Error'){
    if (!this.errorId)
      return ''
    
    else
      return this.errorId+type;
  }

  checkValidatorErrorMessage(index) {
    let error = '';
    if (this.fieldControl.validators[index].message) {
      error = this.fieldControl.validators[index].message;
    }
    return error;
  }

  hasRequiredValidator(validators, key) {
    return validators.map(e => e.type).indexOf(key);
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

  checkForValidatorMessage(errorKey) {
    let error = '';
    const capitalizedKey = this.capitalizeFirstLetter(errorKey)
    if (this.fieldControl && this.fieldControl.validators) {
      const indexValidator = this.hasRequiredValidator(this.fieldControl.validators, capitalizedKey)
      if (indexValidator > -1)
        error = this.checkValidatorErrorMessage(indexValidator);
    }
    return error;
  }

  getErrorMessage(errors: ValidationErrors): string {
    if (!errors)
      return;

    if (errors['pattern'] && this.fieldControl && this.fieldControl.patternErrorMessage)
      return this.fieldControl.patternErrorMessage;
    
    if (this.customMessage)
      return this.customMessage;

    let error: string = this.translate.instant('global.generalValidationError');
    let validateError = "";
    Object.keys(errors).forEach(key => {
      validateError = this.checkForValidatorMessage(key);
      if (!validateError) {
        switch (key) {
          case 'required':
            error = this.translate.instant('global.generalValidationRequired');
            break;
          case 'maxlength':
            error = this.translate.instant('global.generalValidationMaxLength').replace('{{length}}', errors['maxlength'].requiredLength);
            break;
          case 'minlength':
            error = this.translate.instant('global.generalValidationMinLength').replace('{{length}}', errors['minlength'].requiredLength);
            break;
          case 'pattern':
            error = this.translate.instant('global.generalValidationRegex');
            break;
          case 'invalid_birthDate':
            error = this.translate.instant('page.registrationStep2Page.dateofBirth.relativeMaxDate');
            break;
          case 'invalid_date':
            error = this.translate.instant('form.idDetailsSpecificForm.expirationDate.invalidDate');
            break;
          case 'future_date':
            error = this.translate.instant('form.idDetailsSpecificForm.expirationDate.futureDate');
            break;
          case 'past_date':
            error = this.translate.instant('page.registrationStep2Page.dateofBirth.pastDate');
            break;
          case 'invalidField':
            error = errors['invalidField'];
            break;
          case 'emailNotExists':
            error = this.translate.instant('page.registrationStep1Page.emailAddress.error');
            break;
          case 'pixError':
            error = this.translate.instant('page.sendMoneyRecipientBankDepositPage.pixDetailsIDHelperText');
            break;
          case 'invalidAddress':
            error = this.translate.instant('page.registrationStep3Page.POBoxRegex');
            break;
          case 'pixEmailError':
            error = this.translate.instant('page.registrationStep1Page.emailAddress.emailAddressRegex');
            break;
          case 'pixCPFError':
            error = this.translate.instant('page.hubPage.pIXIDValidationLength');
            break;
          case 'pixKeyError':
            error = this.translate.instant('page.hubPage.pIXKeyValidation');
            break;
          case 'breBFormatError':
            error = this.translate.instant('page.sendMoneyRecipientBankDepositPage.brebFormatError');
            break;
          case 'invalid_char':
            error = (errors['message']) ? errors['message'] : "The field contains invalid characters";
            break;
        }
      } else {
        error = validateError;
      }
    });

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-error/rmt-error.ts